/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.roles').service('RolesService',
    function (this: JS5Object, RolesResourceFactory: JS5Object, PaginationService: JS5Object) {
        this.originalEditData;
        this.viewData;

        const responseHandler = (data: JS5Object, responseHeaders: JS5Function) => {
            PaginationService.parseResponseHeaders(responseHeaders());
            PaginationService.pageData = data;
        };

        this.getAllRoles = () => {
            let criteria = {
                fetchLimit: -1,
                fetchOffset: 0
            };
            return RolesResourceFactory.query(criteria).$promise;
        };

        this.getTypedRoles = (mediaType: string) => {
            if (mediaType === 'cc') {
                return this.getAllRoles().then((roles: JS5Object) => {
                    return _.filter(roles, (role) => {
                        return role.type === 'CC';
                    });
                });
            }
            return RolesResourceFactory.query({mediaType: _.capitalize(mediaType)}).$promise;
        };

        this.getAllRolesPaginated = (criteria: JS5Object) => {
            return RolesResourceFactory.query(criteria, responseHandler).$promise;
        };

        this.createRole = (role: JS5Object) => {
            return RolesResourceFactory.save(role).$promise;
        };
        this.getRole = (roleId: number) => {
            return RolesResourceFactory.get({roleId: roleId}).$promise
        };
        this.updateRole = (role: JS5Object) => {
            return RolesResourceFactory.update(role).$promise;
        };
        this.deleteRole = (roleId: number) => {
            return RolesResourceFactory.delete({roleId: roleId}).$promise;
        };
    });
